/**
 * Generated by orval v7.7.0 🍺
 * Do not edit manually.
 * Area Restrita API
 * OpenAPI spec version: 1.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  CompanyDetailQueryResponse,
  CompanyQueryResponse,
  CreateCompanyBody,
  CreateCompanyCommandResponse,
  GetCompaniesParams,
  UpdateCompanyBody
} from '../../model';

import { instance } from '../../index';
import type { ErrorType, BodyType } from '../../index';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getCompany = (
    
 options?: SecondParameter<typeof instance>,signal?: AbortSignal
) => {
      
      
      return instance<CompanyDetailQueryResponse>(
      {url: `/api/v1/company`, method: 'GET', signal
    },
      options);
    }
  

export const getGetCompanyQueryKey = () => {
    return [`/api/v1/company`] as const;
    }

    
export const getGetCompanyInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getCompany>>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCompany>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompany>>> = ({ signal }) => getCompany(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCompany>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetCompanyInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getCompany>>>
export type GetCompanyInfiniteQueryError = ErrorType<unknown>


export function useGetCompanyInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCompany>>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCompany>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompany>>,
          TError,
          Awaited<ReturnType<typeof getCompany>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCompanyInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCompany>>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCompany>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompany>>,
          TError,
          Awaited<ReturnType<typeof getCompany>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCompanyInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCompany>>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCompany>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetCompanyInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCompany>>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCompany>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetCompanyInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetCompanyQueryOptions = <TData = Awaited<ReturnType<typeof getCompany>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompany>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompany>>> = ({ signal }) => getCompany(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompany>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetCompanyQueryResult = NonNullable<Awaited<ReturnType<typeof getCompany>>>
export type GetCompanyQueryError = ErrorType<unknown>


export function useGetCompany<TData = Awaited<ReturnType<typeof getCompany>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompany>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompany>>,
          TError,
          Awaited<ReturnType<typeof getCompany>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCompany<TData = Awaited<ReturnType<typeof getCompany>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompany>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompany>>,
          TError,
          Awaited<ReturnType<typeof getCompany>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCompany<TData = Awaited<ReturnType<typeof getCompany>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompany>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetCompany<TData = Awaited<ReturnType<typeof getCompany>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompany>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetCompanyQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetCompanySuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getCompany>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompany>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompany>>> = ({ signal }) => getCompany(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompany>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetCompanySuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getCompany>>>
export type GetCompanySuspenseQueryError = ErrorType<unknown>


export function useGetCompanySuspense<TData = Awaited<ReturnType<typeof getCompany>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompany>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCompanySuspense<TData = Awaited<ReturnType<typeof getCompany>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompany>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCompanySuspense<TData = Awaited<ReturnType<typeof getCompany>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompany>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetCompanySuspense<TData = Awaited<ReturnType<typeof getCompany>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompany>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetCompanySuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCompanies = (
    params: GetCompaniesParams,
 options?: SecondParameter<typeof instance>,signal?: AbortSignal
) => {
      
      
      return instance<CompanyQueryResponse>(
      {url: `/api/v1/companies`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetCompaniesQueryKey = (params: GetCompaniesParams,) => {
    return [`/api/v1/companies`, ...(params ? [params]: [])] as const;
    }

    
export const getGetCompaniesInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getCompanies>>, GetCompaniesParams['page']>, TError = ErrorType<unknown>>(params: GetCompaniesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCompanies>>, TError, TData, Awaited<ReturnType<typeof getCompanies>>, QueryKey, GetCompaniesParams['page']>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompaniesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanies>>, QueryKey, GetCompaniesParams['page']> = ({ signal, pageParam }) => getCompanies({...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCompanies>>, TError, TData, Awaited<ReturnType<typeof getCompanies>>, QueryKey, GetCompaniesParams['page']> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetCompaniesInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanies>>>
export type GetCompaniesInfiniteQueryError = ErrorType<unknown>


export function useGetCompaniesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCompanies>>, GetCompaniesParams['page']>, TError = ErrorType<unknown>>(
 params: GetCompaniesParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCompanies>>, TError, TData, Awaited<ReturnType<typeof getCompanies>>, QueryKey, GetCompaniesParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompanies>>,
          TError,
          Awaited<ReturnType<typeof getCompanies>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCompaniesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCompanies>>, GetCompaniesParams['page']>, TError = ErrorType<unknown>>(
 params: GetCompaniesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCompanies>>, TError, TData, Awaited<ReturnType<typeof getCompanies>>, QueryKey, GetCompaniesParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompanies>>,
          TError,
          Awaited<ReturnType<typeof getCompanies>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCompaniesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCompanies>>, GetCompaniesParams['page']>, TError = ErrorType<unknown>>(
 params: GetCompaniesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCompanies>>, TError, TData, Awaited<ReturnType<typeof getCompanies>>, QueryKey, GetCompaniesParams['page']>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetCompaniesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCompanies>>, GetCompaniesParams['page']>, TError = ErrorType<unknown>>(
 params: GetCompaniesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCompanies>>, TError, TData, Awaited<ReturnType<typeof getCompanies>>, QueryKey, GetCompaniesParams['page']>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetCompaniesInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetCompaniesQueryOptions = <TData = Awaited<ReturnType<typeof getCompanies>>, TError = ErrorType<unknown>>(params: GetCompaniesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanies>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompaniesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanies>>> = ({ signal }) => getCompanies(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompanies>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetCompaniesQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanies>>>
export type GetCompaniesQueryError = ErrorType<unknown>


export function useGetCompanies<TData = Awaited<ReturnType<typeof getCompanies>>, TError = ErrorType<unknown>>(
 params: GetCompaniesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanies>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompanies>>,
          TError,
          Awaited<ReturnType<typeof getCompanies>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCompanies<TData = Awaited<ReturnType<typeof getCompanies>>, TError = ErrorType<unknown>>(
 params: GetCompaniesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanies>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompanies>>,
          TError,
          Awaited<ReturnType<typeof getCompanies>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCompanies<TData = Awaited<ReturnType<typeof getCompanies>>, TError = ErrorType<unknown>>(
 params: GetCompaniesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanies>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetCompanies<TData = Awaited<ReturnType<typeof getCompanies>>, TError = ErrorType<unknown>>(
 params: GetCompaniesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanies>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetCompaniesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetCompaniesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getCompanies>>, TError = ErrorType<unknown>>(params: GetCompaniesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanies>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompaniesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanies>>> = ({ signal }) => getCompanies(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanies>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetCompaniesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanies>>>
export type GetCompaniesSuspenseQueryError = ErrorType<unknown>


export function useGetCompaniesSuspense<TData = Awaited<ReturnType<typeof getCompanies>>, TError = ErrorType<unknown>>(
 params: GetCompaniesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanies>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCompaniesSuspense<TData = Awaited<ReturnType<typeof getCompanies>>, TError = ErrorType<unknown>>(
 params: GetCompaniesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanies>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCompaniesSuspense<TData = Awaited<ReturnType<typeof getCompanies>>, TError = ErrorType<unknown>>(
 params: GetCompaniesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanies>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetCompaniesSuspense<TData = Awaited<ReturnType<typeof getCompanies>>, TError = ErrorType<unknown>>(
 params: GetCompaniesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanies>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetCompaniesSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const createCompany = (
    createCompanyBody: BodyType<CreateCompanyBody>,
 options?: SecondParameter<typeof instance>,signal?: AbortSignal
) => {
      
      
      return instance<CreateCompanyCommandResponse>(
      {url: `/api/v1/companies`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createCompanyBody, signal
    },
      options);
    }
  


export const getCreateCompanyMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCompany>>, TError,{data: BodyType<CreateCompanyBody>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationOptions<Awaited<ReturnType<typeof createCompany>>, TError,{data: BodyType<CreateCompanyBody>}, TContext> => {
    
const mutationKey = ['createCompany'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCompany>>, {data: BodyType<CreateCompanyBody>}> = (props) => {
          const {data} = props ?? {};

          return  createCompany(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateCompanyMutationResult = NonNullable<Awaited<ReturnType<typeof createCompany>>>
    export type CreateCompanyMutationBody = BodyType<CreateCompanyBody>
    export type CreateCompanyMutationError = ErrorType<unknown>

    export const useCreateCompany = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCompany>>, TError,{data: BodyType<CreateCompanyBody>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationResult<
        Awaited<ReturnType<typeof createCompany>>,
        TError,
        {data: BodyType<CreateCompanyBody>},
        TContext
      > => {

      const mutationOptions = getCreateCompanyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const getCompanyById = (
    id: string,
 options?: SecondParameter<typeof instance>,signal?: AbortSignal
) => {
      
      
      return instance<CompanyDetailQueryResponse>(
      {url: `/api/v1/companies/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetCompanyByIdQueryKey = (id: string,) => {
    return [`/api/v1/companies/${id}`] as const;
    }

    
export const getGetCompanyByIdInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getCompanyById>>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCompanyById>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyByIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyById>>> = ({ signal }) => getCompanyById(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCompanyById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetCompanyByIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyById>>>
export type GetCompanyByIdInfiniteQueryError = ErrorType<unknown>


export function useGetCompanyByIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCompanyById>>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCompanyById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompanyById>>,
          TError,
          Awaited<ReturnType<typeof getCompanyById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCompanyByIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCompanyById>>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCompanyById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompanyById>>,
          TError,
          Awaited<ReturnType<typeof getCompanyById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCompanyByIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCompanyById>>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCompanyById>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetCompanyByIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCompanyById>>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCompanyById>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetCompanyByIdInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetCompanyByIdQueryOptions = <TData = Awaited<ReturnType<typeof getCompanyById>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyById>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyByIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyById>>> = ({ signal }) => getCompanyById(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompanyById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetCompanyByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyById>>>
export type GetCompanyByIdQueryError = ErrorType<unknown>


export function useGetCompanyById<TData = Awaited<ReturnType<typeof getCompanyById>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompanyById>>,
          TError,
          Awaited<ReturnType<typeof getCompanyById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCompanyById<TData = Awaited<ReturnType<typeof getCompanyById>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompanyById>>,
          TError,
          Awaited<ReturnType<typeof getCompanyById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCompanyById<TData = Awaited<ReturnType<typeof getCompanyById>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyById>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetCompanyById<TData = Awaited<ReturnType<typeof getCompanyById>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanyById>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetCompanyByIdQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetCompanyByIdSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getCompanyById>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanyById>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyByIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyById>>> = ({ signal }) => getCompanyById(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanyById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetCompanyByIdSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyById>>>
export type GetCompanyByIdSuspenseQueryError = ErrorType<unknown>


export function useGetCompanyByIdSuspense<TData = Awaited<ReturnType<typeof getCompanyById>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanyById>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCompanyByIdSuspense<TData = Awaited<ReturnType<typeof getCompanyById>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanyById>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCompanyByIdSuspense<TData = Awaited<ReturnType<typeof getCompanyById>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanyById>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetCompanyByIdSuspense<TData = Awaited<ReturnType<typeof getCompanyById>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCompanyById>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetCompanyByIdSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const updateCompany = (
    id: number,
    updateCompanyBody: BodyType<UpdateCompanyBody>,
 options?: SecondParameter<typeof instance>,) => {
      
      
      return instance<CreateCompanyCommandResponse>(
      {url: `/api/v1/companies/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateCompanyBody
    },
      options);
    }
  


export const getUpdateCompanyMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCompany>>, TError,{id: number;data: BodyType<UpdateCompanyBody>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCompany>>, TError,{id: number;data: BodyType<UpdateCompanyBody>}, TContext> => {
    
const mutationKey = ['updateCompany'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCompany>>, {id: number;data: BodyType<UpdateCompanyBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateCompany(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateCompanyMutationResult = NonNullable<Awaited<ReturnType<typeof updateCompany>>>
    export type UpdateCompanyMutationBody = BodyType<UpdateCompanyBody>
    export type UpdateCompanyMutationError = ErrorType<unknown>

    export const useUpdateCompany = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCompany>>, TError,{id: number;data: BodyType<UpdateCompanyBody>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationResult<
        Awaited<ReturnType<typeof updateCompany>>,
        TError,
        {id: number;data: BodyType<UpdateCompanyBody>},
        TContext
      > => {

      const mutationOptions = getUpdateCompanyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    